const backLink = document.getElementById('location-back-link');
if (backLink) {
    backLink.addEventListener('click', event => {
        if (history.length > 1) {
            event.preventDefault();
            history.back();
        }
    });
}
